var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindchillLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.79999 5.28989V1.75818L6.99023 0.138672L3.92682 1.89477L9.79999 5.28989Z",
    fill: "#3D4647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8732 9.15353L13.9366 7.37791V4.13889L10.8732 2.36328V9.15353Z",
    fill: "#3D4647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.20001 10.9883V14.52L6.99026 16.1395L10.0537 14.3834L4.20001 10.9883Z",
    fill: "#3D4647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.04388 12.0025L11.1073 13.7782L13.9366 12.1391V8.60742L8.04388 12.0025Z",
    fill: "#3D4647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.93659 4.27563L2.87317 2.51953L0.0634155 4.13904V7.67075L5.93659 4.27563Z",
    fill: "#3D4647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.12683 7.125L0.0634155 8.90061V12.1396L3.12683 13.9152V7.125Z",
    fill: "#3D4647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindchillLogo);
export default __webpack_public_path__ + "static/media/windchill_logo.102903098540a8ccb214a1783df7c46e.svg";
export { ForwardRef as ReactComponent };